import React, {useEffect, useState, SyntheticEvent} from 'react';
import {NavLink, useHistory} from 'react-router-dom';
import {Form, Button} from 'react-bootstrap';
import api from '../../services/api';
import {toast} from 'react-toastify';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import {Slider} from "@mui/material";

const TokenExportForm = (props) => {
    const [Name, setName] = useState(props?.location?.aboutProps?.name);
    const [Type, setType] = useState('');
    const [Group, setGroup] = useState('');
    const [Schedule, setSchedule] = useState('');
    const [Enabled, setEnabled] = useState(true);
    const [id, setId] = useState(props?.location?.aboutProps?.id);
    const [loadingData, setLoadingData] = useState(false);
    const history = useHistory();
    const [AudioFileOption, setAudioFileOption] = useState('18c');
    const [VolumeOption, setVolumeOption] = useState('25');
    const [AudioFileOptions, setAudioFileOptions] = useState([]);
    const [selectEnabled, setSelectEnabled] = useState(true);
    // const FileDownload = require('js-file-download');

    const exportData = async (e) => {
        e.preventDefault();
        setLoadingData(true);
        try {
            if (value == 'tokenize') {
                toast.info('Feature coming soon', {
                    position: toast.POSITION.TOP_RIGHT
                });
                setLoadingData(false);
                return;
            }
            var file = "";
            if (value == 'qr')
                file = Name + '.svg';

            var optionsFile = "";
            if (value == "us") {
                optionsFile = AudioFileOption;
                let suffix = "";
                switch (optionsFile) {
                    case "17c":
                        suffix = "_17_175_continuous";
                        break;
                    case "17s":
                        suffix = "_17_175_pulsed";
                        break;
                    case "18c":
                        suffix = "_18_195_continuous";
                        break;
                    case "18s5":
                        suffix = "_18_195_pulsed_5s";
                        break;
                    case "18s10":
                        suffix = "_18_195_pulsed_10s";
                        break;
                    case "18s20":
                        suffix = "_18_195_pulsed_20s";
                        break;
                    case "us2p5":
                        suffix = "_US2_pulsed_5s";
                        break;
                    case "us2p10":
                        suffix = "_US2_pulsed_10s";
                        break;
                    case "us3p5":
                        suffix = "_US3_pulsed_5s";
                        break;
                    case "us3p10":
                        suffix = "_US3_pulsed_10s";
                        break;
                    case "18sf20":
                        suffix = "_US_SF_185_pulsed_20s";
                        break;
                }
                file = Name + suffix + '_' + VolumeOption + '.wav';
            }

            api.get('token/' + id + '/export?f=' + value + '&e=' + optionsFile + '&g=' + VolumeOption,
                {
                    
                    responseType: 'blob',
                })
                // 1. Convert the data into 'blob'
                .then((response) => response.data)
                .then((blob) => {

                    // 2. Create blob link to download
                    const url = window.URL.createObjectURL(new Blob([blob]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file);  // 3. Append to html page
                    document.body.appendChild(link);  // 4. Force download
                    link.click();  // 5. Clean up and remove the link
                    link.parentNode.removeChild(link);
                    this.setState({
                        loading: false
                    });
                })
                .catch(function (error) {
                    //Swal.fire({
                    //    title: 'Erreur!',
                    //    text: "Une erreur s'est produite",
                    //    icon: 'error',
                    //    confirmButtonText: 'OK'
                    //});
                    setLoadingData(false);
                });
        } catch (err) {
            toast.error('An error occurred!', {
                position: toast.POSITION.TOP_RIGHT
            });
            setLoadingData(false);
        }
    }

    useEffect(() => {
        // getById();
        var selector = document.getElementById('title-section-id');
        if (selector != undefined) {
            selector.textContent = "Export Token";
        }

        var audioOptions = [
            // {
            //     id: '17c',
            //     name: '17-17.5 kHz, continuous'
            // },
            // {
            //     id: '17s',
            //     name: '17-17.5 kHz, pulsed'
            // },
            {
                id: '18c',
                name: '18-19.5 kHz, continuous'
            },
            {
                id: '18s5',
                name: '18-19.5 kHz, pulsed 5 seconds',
            },
            {
                id: '18s10',
                name: '18-19.5 kHz, pulsed 10 seconds'
            },
            {
                id: '18s20',
                name: '18-19.5 kHz, pulsed 20 seconds'
            },
            {
                id: 'us2p5',
                name: 'US2 17.7-18.1 kHz, pulsed 5 seconds'
            },
            {
                id: 'us2p10',
                name: 'US2 17.7-18.1 kHz, pulsed 10 seconds',
            },
            {
                id: 'us3p5',
                name: 'US3 17.7-18.0 kHz, pulsed 5 seconds'
            },
            {
                id: 'us3p10',
                name: 'US3 17.7-18.0 kHz, pulsed 10 seconds',
            },
            {
                id: '18sf20',
                name: 'US Single Frequency 18.5 kHz, pulsed 20 seconds',
            },
        ];
        setAudioFileOptions(audioOptions);

    }, []);

    const [value, setValue] = React.useState('us');

    const handleChange = (event) => {
        setValue(event.target.value);

        if(event.target.value != "us"){
            setSelectEnabled(false);
        }

        else {
            setSelectEnabled(true);
        }
    };

    return (
        <>
            <div className={loadingData ? "preload" : "d-none"}>
                <div className="preloader-spinner"></div>
            </div>
            <Form className="create-form" onSubmit={exportData} autoComplete="off">
                <div className="card">
                    <div className="card-body">
                        <div className="row">

                                <div className="col-md-3">
                                    <FormControl>
                                        <FormLabel id="demo-controlled-radio-buttons-group"></FormLabel>
                                        <RadioGroup
                                            aria-labelledby="demo-controlled-radio-buttons-group"
                                            name="controlled-radio-buttons-group"
                                            value={value}
                                            onChange={handleChange}
                                        >
                                            <FormControlLabel value="us" control={<Radio/>}
                                                              label="Download UST audio file"/>


                                            {/*<FormControlLabel value="qr" control={<Radio/>} label="Download QR code"/>*/}
                                            <FormControlLabel value="tokenize" control={<Radio/>}
                                                              label="Insert watermarking token"/>
                                        </RadioGroup>
                                    </FormControl>
                                </div>
                            <div className="col-md-9">
                                <select className="form-control audio_file_options d-inline-block" disabled={!selectEnabled} name="AudioFileOption" value={AudioFileOption} onChange={(e) => setAudioFileOption(e.target.value)}>
                                            {AudioFileOptions.map((item, i) => (
                                                <option key={i} value={item.id}>{item.name}</option>
                                            ))}
                                        </select>

                                <select className="form-control audio_file_options d-inline-block ml-0 w-auto" disabled={!selectEnabled} name="VolumeOption" value={VolumeOption} onChange={(e) => setVolumeOption(e.target.value)}>
                                    <option key="25" value="25">25 %</option>
                                    <option key="50" value="50">50 %</option>
                                    <option key="75" value="75">75 %</option>
                                    <option key="100" value="100">100 %</option>
                                </select>

                            </div>



                        </div>
                    </div>
                    <div className="card-footer">
                        <div className="row">
                            <div className="col-12 footer-form">
                                <NavLink className="btn btn-secondary" to="/manage/tokens"><i
                                    className="fa fa-fw fa-times"></i> Cancel</NavLink>
                                <Button className="btn btn-primary" type='submit'><i
                                    className="fa fa-fw fa-floppy-o"></i> Export</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        </>
    );
};

export default TokenExportForm;
